"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const mobx_react_1 = require("mobx-react");
const react_loader_1 = __importDefault(require("react-loader"));
const Defaults_1 = require("../../common/Defaults");
const hui_1 = require("@mit/hui");
const ChangeHoldStatusComponent = ({ person, show, onClose, peopleStore, holds, covidNav, roles, onSubmit }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const handleClose = () => {
        holds.showUpdateStatusModal = false;
        holds.newStatus = undefined;
        setIsLoading(false);
        onClose();
    };
    const submitAndClose = () => {
        setIsLoading(true);
        holds.showUpdateStatusModal = false;
        MedicalApi_1.default.patchVaccineHoldStatus(person.hold_guid, holds.newStatus.id).then((response) => {
            setIsLoading(false);
            if (peopleStore) {
                MedicalApi_1.default.fetchAllVaccineHolds().then((response) => {
                    if (response.items) {
                        peopleStore.setVaccineHoldList(response.items);
                        onSubmit();
                    }
                });
            }
            handleClose();
        });
    };
    const defaultButtonData = [
        { icon: '', text: 'Submit', type: hui_1.ButtonType.Primary, onClick: () => { submitAndClose(); }, state: (roles === null || roles === void 0 ? void 0 : roles.statusDisabled()) ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled },
        { icon: '', text: 'Cancel', type: hui_1.ButtonType.Primary | hui_1.ButtonType.Ghost, onClick: () => { handleClose(); }, state: hui_1.ButtonState.Enabled },
    ];
    const getDropDownItems = () => {
        let dropdownData = [];
        if (holds && holds.statuses) {
            holds.statuses.map((status) => {
                dropdownData.push({ text: status.text, icon: "", id: status.id });
            });
        }
        return dropdownData;
    };
    const getNewStatus = (value) => {
        if (holds && holds.statuses) {
            let newStatus = holds.statuses.find((x) => { return x.text === value.text; });
            return newStatus;
        }
    };
    const setNewStatus = (value) => {
        holds.newStatus = getNewStatus(value);
    };
    const dislay_name = person && person.display_name ? `${person.display_name.split(', ')[1]} ${person.display_name.split(', ')[0]}` : '';
    const cleared_text = covidNav.texts['medical.clear.attestation'].replaceAll('[name]', dislay_name);
    return ((0, jsx_runtime_1.jsx)(hui_1.Drawer, { contentAriaLabel: `Change Hold Status`, header: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: "Change Hold Status", type: hui_1.TextType.Heading3 }) }), type: hui_1.DrawerType.Right, themedColor: "medical", footer: defaultButtonData, contents: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(react_loader_1.default, Object.assign({ loaded: !isLoading, options: Object.assign(Object.assign({}, Defaults_1.mediumLoaderOptions), { color: '#000000' }) }, { children: [(0, jsx_runtime_1.jsx)("p", { children: "You will be changing the hold status to" }), " ", (0, jsx_runtime_1.jsx)(hui_1.Dropdown, { id: "change_vaccine_hold_status", disabled: roles === null || roles === void 0 ? void 0 : roles.statusDisabled(), text: "", dropdownItems: getDropDownItems(), name: "dropdownStatus", value: person === null || person === void 0 ? void 0 : person.status, onChange: (value) => setNewStatus(value) })] })) }), show: show || false, onClose: handleClose, size: hui_1.DrawerSize.Small }));
};
const ChangeHoldStatus = (0, mobx_react_1.inject)('peopleStore', 'holds', 'roles', 'covidNav')((0, mobx_react_1.observer)(ChangeHoldStatusComponent));
exports.default = ChangeHoldStatus;
